import React from "react";
import { Mail, MessageSquare } from "lucide-react";
import { TwilioSettings } from "../../components/settings/TwilioSettings";
import { useSupabase } from "../../contexts/SupabaseContext";
import { SendGridSettings } from "../../components/settings/SendGridSettings";
import { GmailSettings } from "../../components/settings/GmailSettings";
import { EmailComposer } from "../../components/email/EmailComposer";
import { EmailInbox } from "../../components/email/EmailInbox";
import { useBusiness } from "../../contexts/BusinessContext";

export function Integrations() {
  const supabase = useSupabase();
  const { businessId } = useBusiness();

  // Get the current business ID
  React.useEffect(() => {
    const getCurrentBusiness = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (session?.user?.id) {
        const { data: business } = await supabase
          .from("businesses")
          .select("id")
          .eq("owner_id", session.user.id)
          .single();

        if (business) {
          // This is a placeholder for the businessId update logic
          // The businessId is now managed by the useBusiness hook
        }
      }
    };

    getCurrentBusiness();
  }, [supabase]);

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Integrations</h2>

      <div className="space-y-4">
        <GmailSettings />
        {/* Temporary Email UI for Testing */}
        <div className="mt-4 border-t pt-4">
          <h3 className="text-lg font-semibold mb-4">Test Email Interface</h3>
          <div className="space-y-4">
            <EmailComposer />
            <div className="mt-6">
              <EmailInbox />
            </div>
          </div>
        </div>
        <SendGridSettings />
        {businessId && <TwilioSettings businessId={businessId} />}
      </div>
    </div>
  );
}
